import React from 'react';

import { ConnectionString } from './ConnectionString.view';

import './ConnectMessages.scss';

export const NotNodeMessage: React.FC<{
  lastUrl: string;
}> = ({ lastUrl }) => (
  <>
    <h2 className="connect-message-title">Not a node?</h2>
    <p>
      The browser was able to connect to <ConnectionString url={lastUrl} />, but the response
      "didn't" look like a Sesam instance.
    </p>
    <p>Make sure that the url</p>
    <ul>
      <li>
        Points to the <b>api endpoint</b> of the node.
      </li>
      <li>{"Doesn't return 404"}</li>
      <li>
        Returns a JSON document that looks like
        <pre>
          {`{
  "type": "sesam:node"
  [..]
}`}
        </pre>
      </li>
    </ul>
    <p>
      Example url would be <ConnectionString url="https://foobar/api" />
    </p>
  </>
);
